import { colors, levels, typography } from "@vericus/cadmus-ui";

import { Toaster as HotToaster } from "react-hot-toast";

import { ToastBar } from "./ToastBar";

/**
 * Customised react-hot-toast Toaster.
 */
export const Toaster = () => {
  return (
    <HotToaster
      position="bottom-right"
      containerStyle={{
        marginBottom: 65,
        marginRight: 8,
      }}
      toastOptions={{
        duration: 5_000,
        style: {
          padding: "8px 8px 8px 20px",
          fontFamily: typography.headingFive.fontFamily,
          fontWeight: typography.headingFive.fontWeight,
          fontSize: 16,
          lineHeight: typography.headingFive.lineHeight,
          background: colors.black200,
          color: colors.white100,
          boxShadow: levels.three,
          maxWidth: "initial",
          alignItems: "baseline",
          gap: 6,
          boxSizing: "border-box",
        },
        success: {
          iconTheme: {
            primary: "#00A854",
            secondary: colors.white100,
          },
        },
      }}
    >
      {(t) => <ToastBar toast={t} />}
    </HotToaster>
  );
};
